var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.668 9.383a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3.333a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V9.383Z",
    stroke: "#9AA0AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.334 7.383V4.716a3.333 3.333 0 0 1 6.667 0v2.667",
    stroke: "#9AA0AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgLock as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.66797 9.38281C2.66797 8.27824 3.5634 7.38281 4.66797 7.38281H12.668C13.7725 7.38281 14.668 8.27824 14.668 9.38281V12.7161C14.668 13.8207 13.7725 14.7161 12.668 14.7161H4.66797C3.5634 14.7161 2.66797 13.8207 2.66797 12.7161V9.38281Z' stroke='%239AA0AB' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M5.33398 7.38281V4.71615C5.33398 2.8752 6.82637 1.38281 8.66732 1.38281C10.5083 1.38281 12.0007 2.8752 12.0007 4.71615V7.38281' stroke='%239AA0AB' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";